import { render, staticRenderFns } from "./pageDeletionComponent.vue?vue&type=template&id=1c07844e&"
import script from "./pageDeletionComponent.vue?vue&type=script&lang=js&"
export * from "./pageDeletionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports